export { default as Status, StatusProps } from "./Status.component";